import React, { useEffect, useState } from 'react'
import { useNavigate} from 'react-router-dom';
import xhr from '../../utils/fetch';
import LandingMain from '../../components/Landing/LandingMain';
import { BACK_ARROW } from '../../assets/icons';
import BreadCrumb from '../../components/BreadCrumb';
import { LOADING } from '../../assets/animated';
import SubjectCard, { SubjectCategryCard } from '../../components/subects/SubjectCard';
import { CAUTION } from '../../assets/images';
import Footer from '../../components/Landing/Footer';
import { Bot, CodeIcon, Drum, MicVocal, Music2, School2 } from 'lucide-react'
import { SEO } from '../../components/SEO';
function Subjects() {
    const [subjectCat,setSubjectCat] = useState([])
    const [loading,setLoading] = useState(false)
    const navigate = useNavigate();
 
       useEffect(()=>{
        xhr({
           url:`/s/getAllCategories`,
            method:"GET"
        }).then(res=>{
            setLoading(true)
             setSubjectCat(res.data)
        })
          .catch(err=>{
            setLoading(true);
            err
          })
          
    },[])
       const getIcon = (name:string) =>{
    if(name.toLowerCase() === 'non academy'){
      return School2
    }else if(name.toLowerCase() === 'coding'){
      return CodeIcon
    }else if(name.toLowerCase() === 'dance'){
      return Drum
    }else if(name.toLowerCase() === 'ai'){
      return Bot
    }else if(name.toLowerCase() === 'music'){
      return Music2
    }else if(name.toLowerCase() === 'public speaking'){
      return MicVocal
    }
   }
  return (
    <>
    <SEO 
      title="Explore Subjects & Categories - Browse Online Classes"
      description="Explore our wide range of subjects and categories. From academic subjects to music, coding, dance, and more. Find the perfect learning path for you."
      keywords="subjects, categories, online classes, academic subjects, music, coding, dance, AI, public speaking"
      url="/explore"
      type="website"
      og={{
        type: 'website',
        siteName: 'WorldoTutor',
        locale: 'en_US',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'Explore Subjects & Categories - WorldoTutor',
          width: 1200,
          height: 630
        }
      }}
      twitter={{
        card: 'summary_large_image',
        site: '@worldotutor',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'Explore Subjects & Categories - WorldoTutor'
        }
      }}
    />
     <div className=''>
        {/* <div className='bg-primary'>
            <LandingMain title='Explore Our Online Class by Subject Category' subTitle='' searchBox={false}/>
        </div> */}

    
        
          <div className='container mx-auto'>
          <div className="hidden md:flex gap-3 py-5">
          <div
            className="w-8 h-8 flex items-center justify-center bg-neutralBlue2 rounded-full cursor-pointer drop-shadow-md"
            onClick={() => navigate(-1)}
          >
            <img src={BACK_ARROW} alt="Go Back" />
          </div>
          <BreadCrumb />
        </div>
          </div>

                <div className='container md:pt-0 pt-5 '>
        <div className="md:bg-whit flex flex-col gap-4 p-5 rounded">
          <h2 className="text-5xl font-semibold">Subject Categories</h2>
        </div>
          
        </div>

         <div className='py-10 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 container gap-y-10 gap-x-2 mx-auto'>
       { !loading ? (<div className="min-h-[512px] flex items-center justify-center">
            <img src={LOADING} className="w-14 h-14" />
          </div>):(
           <>
           {
            subjectCat.length > 0 ?( 
            subjectCat.map((item:any,indx)=>(
                
                <SubjectCard name={item.name} title={item.description} key={indx} id={item._id} icon={getIcon(item.name)}/>
            ))):(<>
                <div className="flex flex-col gap-5 items-center py-10">
                  <img src={CAUTION} alt="No subjects found" className="rounded-full" />
                  <div className="flex flex-col items-center w-full gap-2">
                    <span className="text-2xl font-medium">Oops,</span>
                    <span className="w-full text-lg font-normal text-center">No Subject found.</span>
                  </div>
                 
                </div>
              </>)
        }
        </>
       )
       }
    </div>
        
     </div>
     <div className="bg-neutralBlack" id="footer">
     <Footer/>
     </div>
     </>
  )
}

export default Subjects
